/* eslint-disable simple-import-sort/sort */
import CoachRank from '/component/partial/report/CoachRank';
import CoachesListHeader from '/component/partial/report/CoachesListHeader';
import HighestAchievedRank from '/component/partial/report/HighestAchievedRank';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import React from 'react';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';
import {ReportProps} from '../Report.types';
import {constant} from 'lodash/fp';
import {generateOnRecordPress} from '../report.util';
import reportPayload from './reportPayload';
import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const CoachesAboveRankContent = ({
  loadingData = {total: 0}, // Default value for loadingData
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }
  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: CoachesListHeader,
        personRoleComponent: CoachRank,
        personInfoComponent: HighestAchievedRank,
        personIsCoach: constant(true),
        onRecordPress: generateOnRecordPress({
          showRecordPopover,
          recordsShowPopover,
          recordsShowRecord,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
